
if (!customElements.get('delivery-time')) {
  customElements.define(
    'delivery-time',
    class DeliveryTime extends HTMLElement {

      connectedCallback() {
        this.mode = this.dataset.deliveryMode || 'text';

        this.content = this.querySelector(
          '.wt-product__delivery-time_content'
        );

        if (!this.content) return;

        // Find the Shopify line-item property input.
        this.propertyInput = this.querySelector(
          '[data-delivery-property]'
        );

        // Initialize the property with the delivery time
        // rendered by Liquid for the initially selected variant.
        this.setPropertyValue(this.content.textContent);

        // Static delivery dates do not change with variants.
        // The line-item property has already been initialized.
        if (
          this.mode === 'days' &&
          this.dataset.static === 'true'
        ) {
          return;
        }

        const dataElement = this.querySelector(
          this.mode === 'days'
            ? '[data-delivery-days]'
            : '[data-delivery-times]'
        );

        if (!dataElement) return;

        try {
          this.variantsData = JSON.parse(dataElement.textContent);
        } catch (error) {
          console.error('Could not parse delivery data:', error);
          return;
        }

        this.onVariantChange = (event) => {
          const variant = event.detail?.variant;
          if (!variant) return;

          this.updateDeliveryTime(variant.id);
        };

        document.addEventListener(
          'variant:changed',
          this.onVariantChange
        );
      }

      disconnectedCallback() {
        if (this.onVariantChange) {
          document.removeEventListener(
            'variant:changed',
            this.onVariantChange
          );
        }

        clearTimeout(this.fadeTimer);
      }

      updateDeliveryTime(variantId) {
        const key = String(variantId);

        // Ignore events for variants belonging
        // to a different product.
        if (!Object.prototype.hasOwnProperty.call(
          this.variantsData, key
        )) {
          return;
        }

        const value = this.variantsData[key];
        let newText = '';

        if (this.mode === 'days') {
          newText = this.calculateDeliveryDates(value);
        } else {
          newText = value || '';
        }

        // Update Shopify line-item property immediately.
        // This happens before the fade animation completes,
        // so Add to Cart always uses the latest value.
        this.setPropertyValue(newText);

        // Update visible text with fade animation.
        this.updateWithFade(newText);
      }

      // Set the hidden Shopify line-item property.
      setPropertyValue(value) {
        if (!this.propertyInput) return;

        this.propertyInput.value = String(value ?? '')
          .replace(/\s+/g, ' ')
          .trim();
      }

      calculateDeliveryDates(expectedDays) {
        if (
          expectedDays === null ||
          expectedDays === undefined ||
          expectedDays === ''
        ) {
          return '';
        }

        const days = Number(expectedDays);
        const range = Number(this.dataset.rangeDays || 0);

        if (!Number.isFinite(days) || !Number.isFinite(range)) {
          return '';
        }

        // Same calculation as our Shopify Liquid.
        // Minimum start date: tomorrow.
        const startOffset = Math.max(1, days - range);
        const endOffset = Math.max(
          startOffset,
          days + range + 1
        );

        // Use the store's calendar date supplied by Liquid.
        // UTC arithmetic prevents browser timezone and DST
        // differences from changing the calendar day.
        const [year, month, day] = this.dataset.today
          .split('-')
          .map(Number);

        const baseDate = Date.UTC(year, month - 1, day);

        const startDate = new Date(
          baseDate + startOffset * 86400000
        );

        const endDate = new Date(
          baseDate + endOffset * 86400000
        );

        const startDay = startDate.getUTCDate();
        const endDay = endDate.getUTCDate();

        const monthFormatter = new Intl.DateTimeFormat(
          'es-ES',
          { month: 'long', timeZone: 'UTC' }
        );

        const startMonth = monthFormatter.format(startDate);
        const endMonth = monthFormatter.format(endDate);

        const sameMonth =
          startDate.getUTCFullYear() === endDate.getUTCFullYear() &&
          startDate.getUTCMonth() === endDate.getUTCMonth();

        const sameDay =
          sameMonth && startDay === endDay;

        if (sameDay) {
          return `Entrega el ${startDay} de ${startMonth}.`;
        }

        if (sameMonth) {
          return `Entrega entre el ${startDay} y el ${endDay} de ${startMonth}.`;
        }

        return `Entrega entre el ${startDay} de ${startMonth} y el ${endDay} de ${endMonth}.`;
      }

      updateWithFade(newText) {
        clearTimeout(this.fadeTimer);

        if (this.content.textContent.trim() === newText) {
          this.classList.remove('fade-out');
          return;
        }

        this.classList.add('fade-out');

        this.fadeTimer = setTimeout(() => {
          this.content.textContent = newText;
          this.classList.remove('fade-out');
        }, 300);
      }
    }
  );
}
